import React, { useEffect, useState, useRef } from 'react';
import { useAppContext } from '../AppContext';
import { AnimatePresence, motion } from 'framer-motion';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const XPFloatingIcon = () => {
    const { t } = useTranslation();
    const { currentUserProfile } = useAppContext();
    const [xpGains, setXpGains] = useState([]);
    const prevXPRef = useRef(currentUserProfile?.constellationXP || 0);

    useEffect(() => {
        const currentXP = currentUserProfile?.constellationXP || 0;
        const prevXP = prevXPRef.current;

        if (currentXP > prevXP) {
            const gained = currentXP - prevXP;
            const id = Date.now();
            setXpGains(prev => [...prev, { id, amount: gained }]);

            // Remove the animation after it completes
            setTimeout(() => {
                setXpGains(prev => prev.filter(g => g.id !== id));
            }, 2000);
        }

        prevXPRef.current = currentXP;
    }, [currentUserProfile?.constellationXP]);

    return (
        <div className="fixed top-16 right-4 z-50 pointer-events-none flex flex-col items-end gap-2">
            <AnimatePresence>
                {xpGains.map(gain => (
                    <motion.div
                        key={gain.id}
                        initial={{ opacity: 0, y: 20, scale: 0.5 }}
                        animate={{ opacity: 1, y: -50, scale: 1 }}
                        exit={{ opacity: 0, y: -100 }}
                        transition={{ duration: 1.5, ease: "easeOut" }}
                        className="flex items-center gap-1 px-3 py-1 bg-indigo-900/90 text-indigo-200 rounded-full border border-indigo-500/50 shadow-glow backdrop-blur-md"
                    >
                        <LucideIcons.Sparkles size={16} className="text-yellow-400" />
                        <span className="font-bold text-sm">+{gain.amount} {t('profileDropdown.xp')}</span>
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};

export default XPFloatingIcon;
